(function () {
  'use strict';

  const KB = window.__KitBuilder;
  if (!KB) return;

  let activeQty = KB.kits[0].qty;
  let selections = [];

  function fmt(cents) {
    return 'R$\u00a0' + (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  function initSelections() {
    selections = Array.from({ length: activeQty }, () => ({
      color: null, size: null, variantId: null
    }));
  }

  function getVariant(color, size) {
    return KB.variants.find(v =>
      v.option1 === color &&
      v.option2 === size &&
      v.available
    ) || null;
  }

  function allDone() {
    return selections.every(s => s.variantId);
  }

  function firstIncomplete() {
    return selections.findIndex(s => !s.variantId);
  }

  function renderQty() {
    const row = document.getElementById('kb-qty-row');
    if (!row) return;
    row.innerHTML = '';

    KB.kits.forEach(kit => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kb-qty-btn' + (kit.qty === activeQty ? ' active' : '');

      const fullPrice = KB.fullPriceCents;
      const hasDiscount = kit.priceEach < fullPrice;
      const pctOff = hasDiscount
        ? Math.round((1 - kit.priceEach / fullPrice) * 100)
        : 0;

      btn.innerHTML =
        '<span class="kb-qty-name">' + kit.label + '</span>' +
        (hasDiscount
          ? '<span class="kb-qty-old-price">' + fmt(fullPrice) + '</span>'
          : '<span class="kb-qty-spacer"></span>') +
        '<span class="kb-qty-price">' + fmt(kit.priceEach) + '/un</span>' +
        (hasDiscount
          ? '<span class="kb-qty-saving">-' + pctOff + '% por un.</span>'
          : '');

      btn.addEventListener('click', function () {
        activeQty = kit.qty;
        initSelections();
        renderQty();
        renderSteps();
        updateTotal();
       const priceWrapper = document.querySelector('.price-display-wrapper');
const priceEl = document.querySelector('span.price-current-bold');
if (priceWrapper && priceEl) {
  const existingCompare = priceWrapper.querySelector('.kb-compare-price');
  if (existingCompare) existingCompare.remove();
  if (kit.qty > 1) {
    const compareSpan = document.createElement('span');
    compareSpan.className = 'kb-compare-price price-compare';
    compareSpan.style.cssText = '';
    compareSpan.textContent = 'R$\u00a0' + (KB.fullPriceCents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    priceWrapper.insertBefore(compareSpan, priceEl);
    priceEl.textContent = 'R$\u00a0' + (kit.priceEach / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
  } else {
    priceEl.textContent = 'R$\u00a0' + (KB.fullPriceCents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
  }
}
      });

      row.appendChild(btn);
    });
  }

  function renderSteps() {
    const container = document.getElementById('kb-steps');
    if (!container) return;
    container.innerHTML = '';

    const colors = KB.options.colors;
    const sizes  = KB.options.sizes;
    const kit    = KB.kits.find(k => k.qty === activeQty);

    selections.forEach(function (sel, i) {
      const done   = !!sel.variantId;
      const isOpen = !done && i === firstIncomplete();

      const step = document.createElement('div');
      step.className = 'kb-step' + (done ? ' kb-step--done' : '');
      step.id = 'kb-step-' + i;

      const summary = done
        ? sel.color + ' · ' + sel.size
        : 'Escolha cor e tamanho';

      const variantImg = sel.color
        ? (KB.variants.find(v => v.option1 === sel.color && v.image) || {}).image || KB.image
        : KB.image;

      step.innerHTML =
        '<div class="kb-step__header" id="kb-header-' + i + '">' +
          '<div class="kb-step__num" id="kb-num-' + i + '">' +
            (done ? '✓' : (i + 1)) +
          '</div>' +
          '<span class="kb-step__title">Item ' + (i + 1) + '</span>' +
          '<span class="kb-step__summary" id="kb-summary-' + i + '">' + summary + '</span>' +
        '</div>' +
        '<div class="kb-step__body' + (isOpen ? ' kb-open' : '') + '" id="kb-body-' + i + '">' +
          '<div class="kb-step__product-row">' +
            '<img class="kb-step__product-img" id="kb-step-img-' + i + '" src="' + variantImg + '" alt="' + KB.title + '">' +
            '<div class="kb-step__product-info">' +
              '<div class="kb-step__product-name">' + KB.title + '</div>' +
              '<div class="kb-step__product-price">' + fmt(kit.priceEach) + '/un</div>' +
            '</div>' +
          '</div>' +
          '<div class="kb-field-label">Cor: <span id="kb-color-name-' + i + '">' +
            (sel.color || 'Selecione') + '</span></div>' +
          '<div class="kb-colors" id="kb-colors-' + i + '"></div>' +
          '<div class="kb-field-label" style="margin-top:12px">Tamanho</div>' +
          '<div class="kb-sizes" id="kb-sizes-' + i + '"></div>' +
          '<button class="kb-next-btn" id="kb-next-' + i + '" type="button" disabled>' +
            (i < activeQty - 1 ? 'IR PARA O PRÓXIMO ITEM →' : 'CONFIRMAR SELEÇÃO ✓') +
          '</button>' +
        '</div>';

      container.appendChild(step);

      document.getElementById('kb-header-' + i).addEventListener('click', function () {
        document.getElementById('kb-body-' + i).classList.toggle('kb-open');
      });

      renderColors(i, colors, sizes);
      renderSizes(i, sizes);
      setupNextBtn(i);
    });
  }

  function triggerNativeColorChange(colorName) {
    const v = KB.variants.find(v => v.option1 === colorName);
    if (!v) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());

    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
      const input = variantPicker.querySelector(
        'input[type="radio"][value="' + colorName + '"]'
      );
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }

  function renderColors(index, colors, sizes) {
    const container = document.getElementById('kb-colors-' + index);
    if (!container) return;
    container.innerHTML = '';

    colors.forEach(function (colorName) {
      const hex = getColorHex(colorName);
      const isLight = isLightColor(hex);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kb-swatch' +
        (selections[index].color === colorName ? ' selected' : '') +
        (isLight ? ' kb-swatch--light' : '');
      btn.style.background = hex;
      btn.title = colorName;

      btn.addEventListener('click', function () {
        selections[index].color = colorName;
        selections[index].size = null;
        selections[index].variantId = null;

        const nameEl = document.getElementById('kb-color-name-' + index);
        if (nameEl) nameEl.textContent = colorName;

        const imgEl = document.getElementById('kb-step-img-' + index);
        if (imgEl) {
          const v = KB.variants.find(v => v.option1 === colorName && v.image);
          if (v && v.image) imgEl.src = v.image;
        }

        triggerNativeColorChange(colorName);

        renderColors(index, colors, sizes);
        renderSizes(index, sizes);
        setupNextBtn(index);
        updateTotal();
      });

      container.appendChild(btn);
    });
  }

  function renderSizes(index, sizes) {
    const container = document.getElementById('kb-sizes-' + index);
    if (!container) return;
    container.innerHTML = '';

    sizes.forEach(function (size) {
      if (!selections[index].color) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kb-size';
        btn.textContent = size;
        container.appendChild(btn);
        return;
      }

      const variant = KB.variants.find(v =>
        v.option1 === selections[index].color &&
        v.option2 === size
      );

      const available = variant && variant.available;

      const alreadySelected = selections.filter((s, si) =>
        si !== index &&
        s.color === selections[index].color &&
        s.size === size
      ).length;

      const inventory = variant ? (variant.inventory || 0) : 0;
      const stockLeft = inventory - alreadySelected;
      const blocked = !available || stockLeft <= 0;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kb-size' +
        (selections[index].size === size ? ' selected' : '') +
        (blocked ? ' unavailable' : '');
      btn.textContent = size + (blocked && available && stockLeft <= 0 ? ' (esgotado)' : '');
      btn.disabled = blocked;

      btn.addEventListener('click', function () {
        if (blocked) return;
        selections[index].size = size;
        const v = getVariant(selections[index].color, size);
        selections[index].variantId = v ? v.id : null;
        renderSizes(index, sizes);
        setupNextBtn(index);
        updateTotal();
      });

      container.appendChild(btn);
    });
  }

  function setupNextBtn(index) {
    const btn = document.getElementById('kb-next-' + index);
    if (!btn) return;
    btn.disabled = !selections[index].variantId;

    btn.onclick = function () {
      const body = document.getElementById('kb-body-' + index);
      if (body) body.classList.remove('kb-open');

      const num = document.getElementById('kb-num-' + index);
      if (num) num.textContent = '✓';

      const step = document.getElementById('kb-step-' + index);
      if (step) step.classList.add('kb-step--done');

      const summary = document.getElementById('kb-summary-' + index);
      if (summary) summary.textContent = selections[index].color + ' · ' + selections[index].size;

      const nextBody = document.getElementById('kb-body-' + (index + 1));
      if (nextBody) nextBody.classList.add('kb-open');

      updateTotal();
      renderSteps();
    };
  }

  function updateMainPrice(priceEach) {
    const priceEl = document.querySelector('span.price-current-bold');
    if (priceEl) {
      priceEl.textContent = 'R$\u00a0' + (priceEach / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
    }
  }

  function updateTotal() {
    const kit    = KB.kits.find(k => k.qty === activeQty);
    const full   = KB.fullPriceCents * activeQty;
    const final  = kit.priceEach * activeQty;
    const saving = full - final;

    const set = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };

    set('kb-total-qty',      activeQty);
    set('kb-total-old',      fmt(full));
    set('kb-total-discount', saving > 0 ? '- ' + fmt(saving) : '—');
    set('kb-total-final',    fmt(final));
    set('kb-total-unit',     fmt(kit.priceEach) + ' por unidade');

    const badge = document.getElementById('kb-saving-badge');
    if (badge) {
      if (saving > 0) {
        badge.textContent = '🎉 Você economiza ' + fmt(saving) + ' neste kit!';
        badge.style.display = 'block';
      } else {
        badge.style.display = 'none';
      }
    }

    const addBtn = document.getElementById('kb-add-btn');
    if (addBtn) addBtn.disabled = !allDone();
  }

  function setupAddBtn() {
    const btn = document.getElementById('kb-add-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (!allDone()) return;

      btn.disabled = true;
      btn.textContent = 'ADICIONANDO...';

      const kit   = KB.kits.find(k => k.qty === activeQty);
      const items = selections.map(s => ({
        id:       s.variantId,
        quantity: 1,
        properties: {
          '_kit': kit.label,
          '_kit_price': fmt(kit.priceEach)
        }
      }));

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items })
      })
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(() => { window.location.href = '/cart'; })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = 'ADICIONAR AO CARRINHO';
        alert('Erro ao adicionar. Tente novamente.');
      });
    });
  }

  const AUTO_CORES = {
    'preto': '#111111', 'preta': '#111111', 'black': '#111111',
    'branco': '#f5f5f5', 'branca': '#f5f5f5', 'white': '#f5f5f5',
    'off white': '#f0ede4', 'off-white': '#f0ede4', 'cru': '#f0e8d6',
    'cinza': '#888888', 'gray': '#888888', 'grey': '#888888',
    'cinza mescla': '#a0a0a0', 'mescla': '#b0b0b0', 'grafite': '#444444',
    'marrom': '#7b4f2e', 'brown': '#7b4f2e', 'caramelo': '#c68642',
    'bege': '#d4b896', 'nude': '#e8c9a0', 'areia': '#e8dcc8',
    'azul': '#1e3a5f', 'blue': '#1e3a5f', 'azul marinho': '#1b2a4a',
    'navy': '#1b2a4a', 'azul royal': '#2155a3', 'indigo': '#3f3cbb',
    'índigo': '#3f3cbb', 'azul claro': '#5b9bd5', 'jeans': '#3b5998',
    'verde': '#2d6a4f', 'green': '#2d6a4f', 'verde musgo': '#4a5e3a',
    'verde oliva': '#6b7c3a', 'verde escuro': '#1b4332', 'kaki': '#7a7c52',
    'vermelho': '#c0392b', 'red': '#c0392b', 'vinho': '#6b1a2a',
    'vermelho telha': '#E35336', 'verde musgo': '#656149',
'azul claro': '#5b9bd5', 'caqui': '#C9B7A0',
    'bordo': '#7b1f2e', 'bordô': '#7b1f2e', 'terracota': '#c1440e',
    'rosa': '#e8a0b0', 'pink': '#e8a0b0', 'rosa claro': '#f4c2c2',
    'lilás': '#c8a0d0', 'roxo': '#6a0dad', 'uva': '#5c2d6e',
    'amarelo': '#f5c518', 'yellow': '#f5c518', 'mostarda': '#c8960c',
    'laranja': '#e8751a', 'orange': '#e8751a', 'coral': '#ff6b6b',
    'dourado': '#c8960c', 'ouro': '#c8960c', 'turquesa': '#40e0d0',
    'petróleo': '#1b4f72', 'azul petróleo': '#1b4f72', 'salmão': '#fa8072',
  };

  function getColorHex(name) {
    if (!name) return '#cccccc';
    const key = name.toLowerCase().trim();
    return (KB.colorHex && KB.colorHex[name]) || AUTO_CORES[key] || '#cccccc';
  }

  function isLightColor(hex) {
    const c = hex.replace('#', '');
    const r = parseInt(c.substr(0,2),16);
    const g = parseInt(c.substr(2,2),16);
    const b = parseInt(c.substr(4,2),16);
    return (r*299 + g*587 + b*114) / 1000 > 180;
  }

  function init() {
    if (!KB.options.colors || !KB.options.sizes) return;
    initSelections();
    renderQty();
   // preço gerenciado pelo Shopify no carregamento
    renderSteps();
    updateTotal();
    setupAddBtn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();